import { Box } from "@mui/material";
import { ReactNode } from "react";

import WebAppAssistantSideBar from "@/common/components/Entity/Assistant/AssistantSideBar";
import { useAppSelector } from "@/common/hooks/redux";
import { useNavDisplay } from "@/common/useNavDisplay";

import Header from "../MainAppView/Header/Header";
import Nav from "../MainAppView/Nav/Nav";
import ChatStack from "../MainAppView/SideStack/ChatStack";

interface MainAppViewProps {
  children: ReactNode;
}

export default function FleetAppLayout({ children }: MainAppViewProps) {
  const isNavOpened = useAppSelector((x) => x.app.isNavOpened);
  const { isControlled, navDisplayWidth } = useNavDisplay();

  return (
    <Box
      data-testid='FleetAppLayout'
      sx={{
        width: "100%",
        height: "100%",
        flex: 1,
        display: "flex",
        overflowX: "hidden",
        overflowY: "hidden",
      }}
    >
      <Box
        data-testid='FleetAppLayout2'
        sx={{
          width: "100%",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          overflowX: "hidden",
          overflowY: "hidden",
        }}
      >
        <Header />

        <Box
          data-testid='FleetAppLayout-ContentWrapper'
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "row",
            alignItems: "flex-start",
            height: "100%",
            width: "100%",
            overflowY: "hidden",
            overflowX: "hidden",
          }}
        >
          {isNavOpened && <Nav />}

          <Box
            data-testid='FleetAppLayout-Content'
            className='AppMainContent'
            sx={{
              // display: "flex",
              // flexDirection: "row",
              // justifyContent: "flex-start",
              // alignItems: "flex-start",
              height: "100%",
              width: "100%",
              overflowY: "auto",
              overflowX: "auto",
              flex: 1,
              minWidth: 0,
              ml: isControlled ? 0 : navDisplayWidth.collapsed,
            }}
          >
            {/* <Box sx={{ width: "100%", height: "fit-content" }}>{children}</Box> */}
            {children}
          </Box>

          {/* Web app assistant side bar */}
          <WebAppAssistantSideBar />

          {/* <Box data-testid='ChatStack-Wrapper'> */}
          <ChatStack />
          {/* </Box> */}
        </Box>
      </Box>
    </Box>
  );
}
